import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {currencyFormat} from "../../../utils/masks";
import {getReport} from "../../../services/Trading";
import {useTranslation} from "react-i18next";
import {FaArrowDown, FaHandHoldingUsd} from "react-icons/fa";
import {
    InsightStack,
    InsightRow,
    InsightIconBox,
    InsightText,
    InsightTitle,
    InsightDesc,
    InsightValue,
    InsightBadge,
    getAccent,
} from "../TradingInsightCard/styles";

export default function CardTotalLoss({filter}) {
    const {coinType, amount} = useSelector((state) => state.BankReducer);
    const [percentQtdeLoss, setPercentQtdeLoss] = useState(null);
    const [, setPercentTotalValueLoss] = useState(null);

    const [totalValueWin, setTotalValueWin] = useState(null);
    const [totalValueLoss, setTotalValueLoss] = useState(null);
    const [qtdeWin, setQtdeWin] = useState(null);
    const [qtdeLoss, setQtdeLoss] = useState(null);
    const [qtdeDraw, setQtdeDraw] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        const value = (qtdeLoss + qtdeWin + qtdeDraw) ? qtdeLoss * 100 / (qtdeLoss + qtdeWin + qtdeDraw) : 0;
        setPercentQtdeLoss(value.toFixed(2));
    }, [qtdeWin, qtdeLoss, qtdeDraw]);

    useEffect(() => {
        const value = (amount && totalValueLoss) ? totalValueLoss * 100 / ((amount - totalValueWin) - totalValueLoss) : 0;
        setPercentTotalValueLoss(value.toFixed(2));
    }, [totalValueLoss, totalValueWin, amount]);

    useEffect(() => {
        getReport({
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
            orderBy: 'profitObtained',
            order: 'DESC'
        }).then((data) => {
            if (!data || data === '' || !data.data) {
                return;
            }

            setTotalValueWin(parseFloat(data.data.win.totalValue ? data.data.win.totalValue : 0));
            setTotalValueLoss(parseFloat(data.data.loss.totalValue ? data.data.loss.totalValue : 0));

            setQtdeWin(data.data.win.qtde);
            setQtdeLoss(data.data.loss.qtde);
            setQtdeDraw(data.data.draw.qtde);
        });
    }, [filter]);

    const a = getAccent('loss');

    return (
        <InsightStack>
            <InsightRow $variant="loss">
                <InsightIconBox $variant="loss">
                    <FaArrowDown aria-hidden/>
                </InsightIconBox>
                <InsightText>
                    <InsightTitle>{t('traging_report_card_loss_defeats')}</InsightTitle>
                    <InsightDesc>{t('trading_report_desc_loss_count')}</InsightDesc>
                </InsightText>
                <InsightValue $color={a.value} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6}}>
                    <span>{qtdeLoss != null ? qtdeLoss : '—'}</span>
                    <InsightBadge $variant="loss" style={{marginLeft: 0}}>{percentQtdeLoss != null ? `${percentQtdeLoss}%` : '—'}</InsightBadge>
                </InsightValue>
            </InsightRow>
            <InsightRow $variant="loss">
                <InsightIconBox $variant="loss">
                    <FaHandHoldingUsd aria-hidden/>
                </InsightIconBox>
                <InsightText>
                    <InsightTitle>{t('traging_report_card_loss_value_defeats')}</InsightTitle>
                    <InsightDesc>{t('trading_report_desc_loss_value')}</InsightDesc>
                </InsightText>
                <InsightValue $color={a.value}>
                    {coinType} {totalValueLoss != null ? currencyFormat(parseFloat(totalValueLoss)) : '—'}
                </InsightValue>
            </InsightRow>
        </InsightStack>
    );
}
